import { z } from 'zod';

// Atoms
export const Company = z
  .object({
    name: z.string(),
  })
  .partial();
export const HubspotCampaignId = z.string().uuid();
export const BotScore = z.number().nonnegative();
export const Email = z.email();

// Molecules
export const ContactFormTrackingEventProperties = z
  .object({
    firstName: z.string(),
    lastName: z.string(),
    title: z.string(),
    email: Email,
    phone: z.string(),
    botScore: BotScore.optional(),
    company: Company.optional(),
    message: z.string(),
    hubspotCampaignId: HubspotCampaignId.optional(),
    successfullyEnriched: z.boolean().optional(),
    enrichedFields: z.array(z.string()).optional(),
    formId: z.string(),
    submissionId: z.string(),
  })
  .partial()
  .optional();
